import { Component } from '@builder.io/sdk';

import { createFontConfigInputs } from './fontConfig';

export const config: Component = {
    name: 'Animated Counter',
    inputs: [
        {
            name: 'targetMode',
            friendlyName: 'Target mode',
            type: 'string',
            defaultValue: 'growth',
            enum: [
                { label: 'Growth', value: 'growth' },
                { label: 'Static target', value: 'staticTarget' },
            ],
            onChange: (options: any) => {
                const mode = options.get('targetMode');
                if (mode === 'growth') {
                    options.set('targetNumber', undefined);
                } else if (mode === 'staticTarget') {
                    options.set('growthRatio', undefined);
                    options.set('delay', undefined);
                }
            },
        },
        {
            name: 'growthRatio',
            type: 'number',
            defaultValue: 600,
            helperText: 'Number of units the counter should grow per second',
            showIf: 'options.get("targetMode") === "growth"',
        },
        {
            name: 'targetNumber',
            type: 'number',
            defaultValue: 1000,
            helperText: 'Number the counter should animate to (static target mode)',
            showIf: 'options.get("targetMode") === "staticTarget"',
        },
        {
            name: 'mode',
            friendlyName: 'Starting value mode',
            type: 'string',
            defaultValue: 'static',
            enum: [
                { label: 'Static number', value: 'static' },
                { label: 'From start date', value: 'startDate' },
                { label: 'Current month', value: 'currentMonth' },
            ],
            onChange: (options: any) => {
                const mode = options.get('mode');
                if (mode === 'static') {
                    options.set('startDate', undefined);
                } else if (mode === 'startDate') {
                    options.set('from', undefined);
                } else if (mode === 'currentMonth') {
                    options.set('from', undefined);
                    options.set('startDate', undefined);
                }
            },
        },
        {
            name: 'from',
            type: 'number',
            defaultValue: 0,
            helperText: 'Starting number for the counter',
            showIf: 'options.get("mode") === "static"',
        },
        {
            name: 'startDate',
            type: 'date',
            helperText: 'Date to start accumulating value from',
            showIf: 'options.get("mode") === "startDate"',
        },
        {
            name: 'duration',
            type: 'number',
            defaultValue: 2,
            helperText: 'Duration in seconds for each growth animation',
        },
        {
            name: 'delay',
            type: 'number',
            defaultValue: 3,
            min: 3,
            helperText:
                'Seconds to wait after each animation completes before starting the next one (minimum of 3 seconds for readability).',
            showIf: 'options.get("targetMode") === "growth"',
        },
        ...createFontConfigInputs(),
        {
            name: 'fontColor',
            type: 'color',
            defaultValue: '#000000',
            helperText: 'Text color',
        },
    ],
};
